import { Link } from "react-router-dom";

export const HouseMark = ({ className = "h-11 w-11" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <path d="M24 5 4 21" stroke="#155B40" strokeWidth="3.5" strokeLinecap="round" />
    <path d="M24 5l20 16" stroke="#155B40" strokeWidth="3.5" strokeLinecap="round" />
    <path d="M9 19.5V43h30V19.5" stroke="#155B40" strokeWidth="3.5" strokeLinejoin="round" />
    <path d="M38 12.5V8h-4.5v2.2" stroke="#155B40" strokeWidth="3" strokeLinecap="round" />
    <rect x="14" y="25" width="7" height="7" stroke="#155B40" strokeWidth="2.4" />
    <path d="M17.5 25v7M14 28.5h7" stroke="#155B40" strokeWidth="1.6" />
    <rect x="27" y="25" width="7" height="7" stroke="#155B40" strokeWidth="2.4" />
    <path d="M30.5 25v7M27 28.5h7" stroke="#155B40" strokeWidth="1.6" />
    <path d="M21 43v-8.5A2.5 2.5 0 0 1 23.5 32h1a2.5 2.5 0 0 1 2.5 2.5V43" fill="#C52232" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="logo-link" className="shrink-0 leading-none" aria-label="Krishnaa Constructions, home">
    <span className="block font-heading text-lg font-black uppercase tracking-wide text-brand-red sm:text-[22px]">
      Krishnaa Constructions
    </span>
    <span className="mt-1 block text-[9.5px] font-bold uppercase tracking-[0.28em] text-brand-green sm:text-[10.5px]">
      All Types of Building Work
    </span>
  </Link>
);
